import React from 'react';
import store from 'store';
import {Input, Button} from 'reactstrap';


class GlobalSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: ''
        }
        this.onSearchChange = this.onSearchChange.bind(this);
        this.setSearch = this.setSearch.bind(this);
    }

    onSearchChange (e) {
		this.setState({search: e.target.value});
	}

    setSearch(){
        store.set("global_search", this.state.search);
        setTimeout(x => {this.props.history.push('/latest')}, 100)
		
    }

    render() {
        return (
            <div className="global-search">
                <Input
                    name="search"
                    placeholder='Search...'
                    value={this.state.search}
                    title={this.state.search !== ''? this.state.search : 'Search...'}
                    onChange={this.onSearchChange}
                    className="search-field-input"
                    //style={{borderRadius: '0.25rem 0 0 0.25rem'}}
                    style={{borderRadius: '0'}}
                    autoComplete="off"
                />
                <Button className="btn btn-primary-new" onClick={this.setSearch}>Search</Button>
            </div>
        )
    }
}
export default GlobalSearch;


// WEBPACK FOOTER //
// ./src/components/Header/GlobalSearch.js